import { getMeasurementState } from "../../../stores/measurementStore";

function getMeasurementHitLabel(object, bodyUuid) {
  const userData = object?.userData || {};
  if (userData.geomName) return String(userData.geomName);
  if (userData.meshName) return String(userData.meshName);
  if (userData.bodyName) return String(userData.bodyName);
  return bodyUuid ? String(bodyUuid) : null;
}

function isMeasurementPickableHit(hit) {
  const object = hit?.object;
  if (!object?.isMesh || !object.visible) return false;
  const userData = object.userData || {};
  if (userData.isMeasurementOverlay || userData.isMassPropertiesComMarker) return false;
  if (userData.selectable === false) return false;
  return Boolean(hit.point);
}

export function handleMeasurementPickClick({ event, getOwningBodyUuidForObject, intersects }) {
  const state = getMeasurementState();
  if (!state.activeTool) return false;
  if (event.button !== 0 || window.isRadialClickModeActive) return true;

  const hit = (intersects || []).find(isMeasurementPickableHit);
  if (!hit) return true;

  const bodyUuid = getOwningBodyUuidForObject(hit.object) || hit.object?.userData?.bodyUuid || null;
  state.actions.addSurfacePoint({
    position: [hit.point.x, hit.point.y, hit.point.z],
    bodyUuid,
    label: getMeasurementHitLabel(hit.object, bodyUuid),
  });
  return true;
}
